import { render, staticRenderFns } from "./RoomSticker.vue?vue&type=template&id=95a0ee68&"
import script from "./RoomSticker.vue?vue&type=script&lang=js&"
export * from "./RoomSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a0ee68')) {
      api.createRecord('95a0ee68', component.options)
    } else {
      api.reload('95a0ee68', component.options)
    }
    module.hot.accept("./RoomSticker.vue?vue&type=template&id=95a0ee68&", function () {
      api.rerender('95a0ee68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Sticker/RoomSticker.vue"
export default component.exports